module.exports = __webpack_public_path__ + "media/site_templates/www.floor-sanding.net.au/images/splash-9b410debfe8dd11cc169aae738335828.jpg";